<template>
  <div>
    <PageAllow controller="Materials" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet
        v-show="!(currentItemMode || importMaterialsResultFlg)"
        class="transparent-background-color"
      >
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="materialKeyword = $event"
                :label="$t('Material.materialKeyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="settings && settings.sync_hml_data == 1"
                small
                color="warning"
                @click.stop="syncHuaManLouMaterials()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Material.actions.syncThirdMaterial") }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  settings.push_platform != 1018 &&
                  settings.push_platform <= 2000 &&
                  !sync_material_data_from && // 有三方对接但基础信息以本地录入形式处理
                  settings.new_material_add != 0 &&
                  $permission.permissionAllow('Materials', 'add')
                "
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  (settings.push_platform == 1018 ||
                    settings.push_platform > 2000 ||
                    sync_material_data_from) &&
                  $permission.permissionAllow('Materials', 'add')
                "
                small
                dark
                color="warning"
                class="ms-1"
                @click.stop="syncKingdeeMaterials()"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Material.actions.syncWithKingdee") }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  settings.sync_third_base_materials &&
                  settings.sync_third_base_materials == 1
                "
                small
                dark
                color="warning"
                class="ms-1"
                @click.stop="syncThirdMaterial()"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Material.actions.syncThirdMaterial") }}
              </v-btn>
              <v-menu
                v-model="importBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
                v-if="
                  $permission.permissionAllow('Materials', 'newImport') ||
                  $permission.permissionAllow('Materials', 'postImages') ||
                  $permission.permissionAllow(
                    'Materials',
                    'importMaterialImgZip'
                  )
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1"
                  >
                    <v-icon x-small class="pe-1">fa-file-import</v-icon>
                    {{ $t("Import.import", [$t("Material.ObjectName")]) }}
                    <v-icon x-small class="ps-1">{{
                      importBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    @click.stop="ImportDialog = true"
                    v-if="$permission.permissionAllow('Materials', 'newImport')"
                  >
                    <v-icon x-small class="pe-2">fa-file-excel</v-icon>
                    <v-list-item-title>
                      {{ $t("Import.import", [$t("Material.ObjectName")]) }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="newAddImportDialog = true"
                    v-if="
                      $permission.permissionAllow('Materials', 'newAddImport')
                    "
                  >
                    <v-icon x-small class="pe-2">fa-file-excel</v-icon>
                    <!-- 新增商品导入 -->
                    <v-list-item-title>
                      {{ $t("Material.Import.newAddImport") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="newEditImportDialog = true"
                    v-if="
                      $permission.permissionAllow('Materials', 'newEditImport')
                    "
                  >
                    <v-icon x-small class="pe-2">fa-file-excel</v-icon>
                    <!-- 编辑商品导入 -->
                    <v-list-item-title>
                      {{ $t("Material.Import.newEditImport") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="ImportImagesDialog = true"
                    v-if="
                      $permission.permissionAllow('Materials', 'postImages')
                    "
                  >
                    <v-icon x-small class="pe-2">fa-file-image</v-icon>
                    <v-list-item-title>
                      {{ $t("Material.Import.batchImportImages") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="batchImportDialog = true"
                    v-if="
                      $permission.permissionAllow(
                        'Materials',
                        'importMaterialImgZip'
                      )
                    "
                  >
                    <v-icon x-small class="pe-2">fa-file-archive</v-icon>
                    <v-list-item-title>
                      {{ $t("Material.Import.zipImportImages") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="zipImportAlbumsDialog = true"
                    v-if="
                      $permission.permissionAllow('Materials', 'importAlbumZip')
                    "
                  >
                    <v-icon x-small class="pe-2">fa-file-archive</v-icon>
                    <v-list-item-title>
                      {{ $t("Material.Import.zipImportAlbums") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu
                v-if="
                  $permission.permissionAllow('Materials', 'newExport') ||
                  $permission.permissionAllow('Materials', 'export')
                "
                v-model="exportBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1"
                  >
                    <v-icon x-small class="pe-1">fa-file-export</v-icon>
                    {{ $t("Export.export", [$t("Material.ObjectName")]) }}
                    <v-icon x-small class="ps-1">{{
                      exportBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    @click.stop="newExportExcel()"
                    v-if="$permission.permissionAllow('Materials', 'newExport')"
                  >
                    <v-icon x-small class="pe-2">fa-file-excel</v-icon>
                    <v-list-item-title>
                      {{ $t("Export.new_export", [$t("Material.ObjectName")]) }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="exportExcel()"
                    v-if="$permission.permissionAllow('Materials', 'export')"
                  >
                    <v-icon x-small class="pe-2">fa-file-export</v-icon>
                    <v-list-item-title>
                      {{ $t("Export.export", [$t("Material.ObjectName")]) }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu
                v-model="formulaImportBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
                v-if="
                  $permission.permissionAllow(
                    'Materials',
                    'combineFormulaImport'
                  ) ||
                  $permission.permissionAllow('Materials', 'splitFormulaImport')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1"
                  >
                    <v-icon x-small class="pe-1">fa-file-import</v-icon>
                    {{ $t("Import.import", [$t("Material.formula")]) }}
                    <v-icon x-small class="ps-1">{{
                      formulaImportBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    @click.stop="combineFormulaImportDialog = true"
                    v-if="
                      $permission.permissionAllow(
                        'Materials',
                        'combineFormulaImport'
                      )
                    "
                  >
                    <v-icon x-small class="pe-2">fa-file-excel</v-icon>
                    <v-list-item-title>
                      {{ $t("Import.import", [$t("Material.combineFormula")]) }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="splitFormulaImportDialog = true"
                    v-if="
                      $permission.permissionAllow(
                        'Materials',
                        'splitFormulaImport'
                      )
                    "
                  >
                    <v-icon x-small class="pe-2">fa-file-excel</v-icon>
                    <v-list-item-title>
                      {{ $t("Import.import", [$t("Material.splitFormula")]) }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- 批量上下架 -->
              <v-menu
                v-if="
                  $permission.permissionAllow(
                    'Materials',
                    'batchUpdateMaterialField'
                  )
                "
                v-model="batchUpdatePublicBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1"
                  >
                    {{ $t("Material.batchPublic") }}
                    <v-icon x-small class="ps-1">{{
                      batchUpdatePublicBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click.stop="publicFlgOnAlert = true">
                    <v-list-item-title>
                      {{ $t("Material.public_flg_on") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click.stop="publicFlgOffAlert = true">
                    <v-list-item-title>
                      {{ $t("Material.public_flg_off") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- <v-btn
                v-if="$permission.permissionAllow('Materials', 'newExport')"
                small
                color="print"
                dark
                @click.stop="newExportExcel()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("Export.new_export", [$t("Material.ObjectName")]) }}
              </v-btn> -->
              <!-- <v-btn
                v-if="$permission.permissionAllow('Materials', 'export')"
                small
                color="print"
                dark
                @click.stop="exportExcel()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("Export.export", [$t("Material.ObjectName")]) }}
              </v-btn> -->
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategory v-model="categorySelected" />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    settings &&
                    settings.miniprogram &&
                    (settings.miniprogram.template_id == '4' ||
                      settings.miniprogram.template_id == '3')
                  "
                >
                  <SearcherMaterialShowCategories
                    v-model="showCategoriesSelected"
                  />
                </v-col>
                <v-col
                  v-if="settings && settings.material_group_enable"
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <SearcherSelect
                    ref="material_group"
                    v-model="options.material_group"
                    :items="material_groups"
                    :label="$t('Material.Fields.material_group')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherSelect
                    ref="storage_conditions"
                    v-model="options.storage_conditions"
                    :items="material_storage_conditions"
                    :label="$t('Material.Fields.storage_conditions')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherSelect
                    ref="brand"
                    v-model="options.brand"
                    :items="material_brands"
                    :label="$t('Material.Fields.brand')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherSelect
                    ref="origin"
                    v-model="options.origin"
                    :items="material_origins"
                    :label="$t('Material.Fields.origin')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherSuppliers
                    ref="supplierSelected"
                    v-model="supplierSelected"
                    :label="$t('Material.Fields.default_supplier')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <div
                        class="caption grey--text input-chip-group-label"
                        :class="
                          $vuetify.theme.dark
                            ? 'text--lighten-1'
                            : 'text--darken-1'
                        "
                      >
                        {{ $t("Material.Fields.public_flg") }}
                      </div>
                      <v-chip-group
                        v-model="options.public_flgs"
                        column
                        multiple
                        class="mx-1"
                      >
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="primary"
                          text-color="white"
                          :key="1"
                          :value="1"
                          >{{ $t("Material.publicFlgs.on") }}</v-chip
                        >
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="grey"
                          text-color="white"
                          :key="0"
                          :value="0"
                          >{{ $t("Material.publicFlgs.off") }}</v-chip
                        >
                      </v-chip-group>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div
                        class="caption grey--text input-chip-group-label"
                        :class="
                          $vuetify.theme.dark
                            ? 'text--lighten-1'
                            : 'text--darken-1'
                        "
                      >
                        {{ $t("Material.Fields.alcohol_flg") }}
                      </div>
                      <v-chip-group
                        v-model="options.alcohol_flgs"
                        column
                        multiple
                        class="mx-1"
                      >
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="primary"
                          text-color="white"
                          :key="0"
                          :value="0"
                        >
                          {{ $t("Material.alcoholFlg.off") }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="grey"
                          text-color="white"
                          :key="1"
                          :value="1"
                        >
                          {{ $t("Material.alcoholFlg.on") }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    $permission.permissionAllow('FoodFormula', 'index') ||
                    (settings && settings.production_module == 1)
                  "
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="$permission.permissionAllow('FoodFormula', 'index')"
                    >
                      <div
                        class="caption grey--text input-chip-group-label"
                        :class="
                          $vuetify.theme.dark
                            ? 'text--lighten-1'
                            : 'text--darken-1'
                        "
                      >
                        {{ $t("Material.raw_material_flgs.title") }}
                      </div>
                      <v-chip-group
                        v-model="options.raw_material_flgs"
                        column
                        multiple
                        class="mx-1"
                      >
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="primary"
                          text-color="white"
                          :key="0"
                          :value="0"
                          >{{ $t("Material.raw_material_flgs.off") }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="grey"
                          text-color="white"
                          :key="1"
                          :value="1"
                          >{{ $t("Material.raw_material_flgs.on") }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="settings && settings.production_module == 1"
                    >
                      <div
                        class="caption grey--text input-chip-group-label"
                        :class="
                          $vuetify.theme.dark
                            ? 'text--lighten-1'
                            : 'text--darken-1'
                        "
                      >
                        {{ $t("Material.production_attribute_flgs.title") }}
                      </div>
                      <v-chip-group
                        v-model="options.production_attribute_flgs"
                        column
                        multiple
                        class="mx-1"
                      >
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="primary"
                          text-color="white"
                          :key="0"
                          :value="0"
                        >
                          {{ $t("Material.production_attribute_flgs.off") }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          filter
                          class="mx-1"
                          color="grey"
                          text-color="white"
                          :key="1"
                          :value="1"
                        >
                          {{ $t("Material.production_attribute_flgs.on") }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Material.material_img_flgs.title") }}
                  </div>
                  <v-chip-group
                    v-model="options.material_img_flgs"
                    column
                    multiple
                    class="mx-1"
                  >
                    <v-chip
                      small
                      label
                      filter
                      class="mx-1"
                      color="primary"
                      text-color="white"
                      :key="0"
                      :value="0"
                    >
                      {{ $t("Material.material_img_flgs.uploaded") }}
                    </v-chip>
                    <v-chip
                      small
                      label
                      filter
                      class="mx-1"
                      color="grey"
                      text-color="white"
                      :key="1"
                      :value="1"
                    >
                      {{ $t("Material.material_img_flgs.notUpload") }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="materials"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-2 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
            mobile-breakpoint="800"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.material_name="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              <v-avatar
                v-if="settings.material_image"
                tile
                color="bgGrey"
                style="vertical-align: top"
                class="my-1 mr-4"
              >
                <v-menu open-on-hover :key="item.material_img">
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      v-if="item.thumbnail || item.material_img"
                      alt="Avatar"
                      :src="
                        item.thumbnail
                          ? item.thumbnail
                          : item.material_img + '?x-image-process=style/160x160'
                      "
                    />
                  </template>
                  <v-img :src="item.material_img" width="160" />
                </v-menu>
              </v-avatar>
              <div class="d-inline-block ma-1">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="d-block text-truncate"
                      style="max-width: 430px; cursor: pointer"
                      @dblclick="
                        currentItemMode = 'edit';
                        currentItem = item;
                      "
                      >{{ item.material_name }}
                    </span>
                  </template>
                  {{ item.material_name }}
                </v-tooltip>
                <span class="caption secondary--text">
                  {{ item.material_code }}
                </span>
              </div>
            </template>
            <template v-slot:item.show_categories="{ item }">
              <v-tooltip
                right
                v-if="item.show_categories && item.show_categories.length > 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{
                      item.show_categories[0].parent_show_category
                        ? item.show_categories[0].parent_show_category.name +
                          " : "
                        : ""
                    }}
                    {{ item.show_categories[0].name }}
                    {{ item.show_categories.length > 1 ? "..." : "" }}
                  </span>
                </template>
                <span
                  v-for="(show_category, index) in item.show_categories"
                  :key="show_category.id"
                  class="d-inline"
                >
                  {{
                    show_category.parent_show_category
                      ? show_category.parent_show_category.name + " : "
                      : ""
                  }}
                  {{
                    show_category.name +
                    (index == item.show_categories.length - 1 ? "" : ",")
                  }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item.standard.name="{ item }">
              <span
                v-if="
                  item.standard &&
                  item.standard.name &&
                  item.standard.name.length > 12
                "
                :title="item.standard.name"
                style="cursor: pointer"
              >
                {{ item.standard.name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard ? item.standard.name : "" }}
              </span>
            </template>
            <template v-slot:item.supply_price="{ item }">
              {{ $t("Global.money") }}{{ item.supply_price | formatMoney }}
            </template>
            <template v-slot:item.public_flg="{ item }">
              <v-edit-dialog
                :return-value.sync="item.public_flg"
                large
                :cancel-text="$t('CRUD.abandon')"
                :save-text="$t('CRUD.confirm')"
                @open="currentItemPublic = JSON.parse(JSON.stringify(item))"
                @save="
                  updateMaterialPublicFlg(currentItemPublic.public_flg, item.id)
                "
              >
                <v-chip
                  small
                  label
                  :color="item.public_flg ? 'primary' : 'grey'"
                  text-color="white"
                >
                  {{
                    item.public_flg
                      ? $t("Material.publicFlgs.on")
                      : $t("Material.publicFlgs.off")
                  }}
                </v-chip>
                <template v-slot:input>
                  <div v-if="currentItemPublic">
                    <div class="mt-4 title">
                      {{ $t("Material.Fields.public_flg") }}
                    </div>

                    <v-row align="center">
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="currentItemPublic.public_flg"
                        >
                          <v-radio
                            :label="$t('Material.publicFlgs.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('Material.publicFlgs.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.alcohol_flg="{ item }">
              <v-chip
                small
                label
                dark
                :color="item.alcohol_flg ? 'grey' : 'primary'"
              >
                {{
                  item.alcohol_flg
                    ? $t("Material.alcoholFlg.on")
                    : $t("Material.alcoholFlg.off")
                }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Materials', 'view')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("Material.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Materials', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("Material.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Materials', 'copy')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'clone';
                      currentItem = item;
                    "
                    >fa-clone
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.cloneInfo", [$t("Material.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Materials', 'delete')"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                  v-if="item.deletable"
                >
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      checkEditAndDelete();
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <template v-slot:activator="{ on, attrs }" v-else>
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      getStockMaterials();
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("Material.ObjectName")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <MaterialDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      @mode="currentItemMode = $event"
      @save="getMaterialsFromAPI()"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Material.ObjectName')"
      @confirm="
        deleteMaterial();
        deleteDialog = false;
      "
    />
    <v-dialog v-model="deleteAlertDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="deleteAlertDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 subtitle-1">
          {{ $t("Material.deleteAlert.title") }}
          <div class="pl-5" v-for="(alert, index) in deleteAlert" :key="index">
            {{ index + 1 }}
            {{ $t("Global.pause") }}
            {{ alert.stock_name }}
            {{ $t("Global.colon") }}
            {{ alert.stock_unit_num }}
          </div>
          {{ $t("Material.deleteAlert.message") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="deleteAlertDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="deleteAlertDialog = false">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ImportMaterialsResult
      v-show="importMaterialsResultFlg"
      v-model="importMaterialsResult"
      v-on:close="
        importMaterialsResultFlg = false;
        getMaterialsFromAPI();
      "
    />
    <!-- <v-dialog v-model="ImportDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Import.import", [$t("Material.ObjectName")]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="ImportDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-left my-2">
                {{
                  $t("Import.downloadFieldTemplate", [
                    $t("Material.ObjectName"),
                  ])
                }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-btn
                  color="primary"
                  dark
                  class="ms-1"
                  :href="
                    $BaseURL + 'download/template/material_import_template.xls'
                  "
                >
                  {{ $t("Import.downloadFieldTemplateBtn") }}
                </v-btn>
              </v-list-item-subtitle>
              <v-list-item-title class="text-left my-2">
                {{ $t("Import.uploadField", [$t("Material.ObjectName")]) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-file-input
                  v-model="excelFile"
                  show-size
                  :label="$t('Import.fileInputLabel')"
                  accept=".xls,.xlsx"
                ></v-file-input>
              </v-list-item-subtitle>
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-left my-1">
                {{ $t("Material.importAlertOne") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-left my-1">
                {{ $t("Material.importAlertTwo") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="ImportDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="importExcel()">
            {{ $t("Import.confirmImport") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('Material.ObjectName')"
      isTips
      :tipDetails="[
        $t('Material.importAlertOne'),
        $t('Material.importAlertTwo'),
      ]"
      :downloadTemplateUrl="
        settings && settings.production_module
          ? 'download/template/material_product_new_import_template.xls'
          : 'download/template/material_new_import_template.xls'
      "
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportExcelAlert
      v-model="newAddImportDialog"
      :title="$t('Material.Import.newAddImport')"
      :objName="$t('Material.ObjectName')"
      isTips
      :tipDetails="[
        $t('Material.importAlertOne'),
        $t('Material.importAlertTwo'),
      ]"
      :downloadTemplateUrl="
        settings && settings.production_module
          ? 'download/template/material_product_new_import_template.xls'
          : 'download/template/material_new_import_template.xls'
      "
      @import="
        newAddExcelFile = $event;
        newAddImportExcel();
      "
    />
    <ImportExcelAlert
      v-model="newEditImportDialog"
      :title="$t('Material.Import.newEditImport')"
      :objName="$t('Material.ObjectName')"
      isTips
      :tipDetails="[
        $t('Material.importAlertOne'),
        $t('Material.importAlertTwo'),
      ]"
      :downloadTemplateUrl="
        settings && settings.production_module
          ? 'download/template/material_product_new_import_template.xls'
          : 'download/template/material_new_import_template.xls'
      "
      @import="
        newEditExcelFile = $event;
        newEditImportExcel();
      "
    />
    <ImportExcelAlert
      v-model="combineFormulaImportDialog"
      :objName="$t('Material.combineFormula')"
      isTips
      :tipDetails="[$t('Material.Import.formulaImportAlert')]"
      downloadTemplateUrl="download/template/组装配方导入模版.xlsx"
      @import="
        combineFormulaExcelFile = $event;
        combineFormulaImportExcel();
      "
    />
    <ImportExcelAlert
      v-model="splitFormulaImportDialog"
      :objName="$t('Material.splitFormula')"
      isTips
      :tipDetails="[$t('Material.Import.formulaImportAlert')]"
      downloadTemplateUrl="download/template/拆零配方导入模版.xlsx"
      @import="
        splitFormulaExcelFile = $event;
        splitFormulaImportExcel();
      "
    />
    <ImportZipAlert
      v-model="batchImportDialog"
      :title="$t('Material.Import.batchImportImagesZip')"
      :objName="$t('Material.Import.zipObjName')"
      @import="
        zipFile = $event;
        ImportZip();
      "
      isTips
      :tipDetails="[
        $t('Material.Import.zipImportAlertOne'),
        $t('Material.Import.zipImportAlertTwo'),
        $t('Material.Import.zipImportAlertThree'),
        $t('Material.Import.zipImportAlertFour'),
      ]"
    />
    <ImportZipAlert
      v-model="zipImportAlbumsDialog"
      :title="$t('Material.Import.zipImportAlbums')"
      :objName="$t('Material.Import.albumsObjName')"
      @import="
        albumZipFile = $event;
        ImportAlbumsZip();
      "
      isTips
      :tipDetails="[
        $t('Material.Import.zipImportAlertOne'),
        $t('Material.Import.zipImportAlertTwo'),
        $t('Material.Import.zipImportAlertThree'),
        $t('Material.Import.zipImportAlertFour'),
      ]"
    />
    <ImportImages
      v-model="ImportImagesDialog"
      :title="$t('Material.Import.imagesUpload')"
      :objName="$t('Material.Import.images')"
      @refresh="getMaterialsFromAPI()"
      isTips
      :tipDetails="[
        $t('Material.Import.imagesImportAlertOne'),
        $t('Material.Import.imagesImportAlertTwo'),
        $t('Material.Import.imagesImportAlertthree'),
      ]"
    />
    <ErrorShopDialog v-model="errorShopDataDialog" :errorData="errorShopData" />
    <PublicErrDialog v-model="publicErrFlg" :errorData="publicErrData" :title="publicErrMsg" />
    <!-- 批量上架 -->
    <DialogAlert
      v-model="publicFlgOnAlert"
      :message="$t('Material.messages.publicFlgOnAlert')"
      useConfirm
      @confirm="
        updateMaterialPublicFlg(1);
        publicFlgOnAlert = false;
      "
    />
    <!-- 批量下架 -->
    <DialogAlert
      v-model="publicFlgOffAlert"
      :message="$t('Material.messages.publicFlgOffAlert')"
      useConfirm
      @confirm="
        updateMaterialPublicFlg(0);
        publicFlgOffAlert = false;
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherSelect from "@/components/plugins/SearcherSelect";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherMaterialShowCategories from "@/components/plugins/SearcherMaterialShowCategories";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";
import MaterialDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import Materials from "@/api/materials";
import ImportMaterialsResult from "./plugins/importMaterialsResult";
import KingdeeWorker from "@/api/kingdee_worker";
import YywdMiddleware from "@/api/yywd_middleware";
import YywdNewMiddleware from "@/api/yywd_new_middleware";
import ImportZipAlert from "./plugins/ImportZipAlert";
import ImportImages from "./plugins/ImportImages";
import ErrorShopDialog from "./plugins/ErrorShopDialog";
import DialogAlert from "@/components/plugins/DialogAlert";
import PublicErrDialog from "./plugins/PublicErrDialog";

const defaultOptions = {
  keyword: "",
  category_code: "",
  show_category_ids: [],
  material_group: "",
  storage_conditions: "",
  brand: "",
  origin: "",
  public_flgs: [1],
  alcohol_flgs: [0, 1],
  raw_material_flgs: [0],
  production_attribute_flgs: [0],
  material_img_flgs: [0, 1],
  sortBy: [],
  sortDesc: [],
  supplier_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherSelect,
    SearcherMaterialCategory,
    SearcherMaterialShowCategories,
    SearcherSuppliers,
    MaterialDetail,
    DialogDelete,
    ImportExcelAlert,
    ImportMaterialsResult,
    ImportZipAlert,
    ImportImages,
    ErrorShopDialog,
    DialogAlert,
    PublicErrDialog,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          replace: true,
          href: "/materials",
          click: function () {
            this.currentItemMode = null;
            this.currentItem == null;
          }.bind(this),
        },
        {
          text: i18n.t("Nav.materials"),
          disabled: true,
          href: "/materials",
        },
      ];
      return items;
    },
    headers() {
      var headers = [
        {
          text: i18n.t("Material.Fields.material"),
          align: "start",
          sortable: true,
          value: "material_name",
          width: 350,
        },
        {
          text: i18n.t("Material.Fields.material_category"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "material_category.name",
        },
      ];
      if (
        this.settings &&
        this.settings.miniprogram &&
        (this.settings.miniprogram.template_id == "4" ||
          this.settings.miniprogram.template_id == "3")
      )
        headers.push({
          text: i18n.t("Material.Fields.material_show_categories"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "show_categories",
        });
      return headers.concat([
        {
          text: i18n.t("Material.Fields.default_unit"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "standard.default_standard_detail.unit",
        },
        {
          text: i18n.t("Material.Fields.standard"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "standard.name",
        },
        {
          text: i18n.t(
            "Material.Fields.supply_price_default",
            this.$store.state.settings
              ? [this.$store.state.settings.shop_custom_name]
              : []
          ),
          align: "end",
          class: "text-no-wrap",
          sortable: false,
          value: "supply_price",
        },
        {
          text: i18n.t("Material.Fields.storage_conditions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "storage_conditions",
        },
        {
          text: i18n.t("Material.Fields.alcohol_flg"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "alcohol_flg",
        },
        {
          text: i18n.t("Material.Fields.public_flg"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "public_flg",
        },
        {
          text: i18n.t("Material.Fields.default_supplier"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "supplier.supplier_name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          width: this.stickTableCols ? "140" : "default",
          sortable: false,
          value: "actions",
        },
      ]);
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "loading",
      "settings",
      "sync_material_data_from",
      "stickTableCols",
      "allow",
    ]),
  },

  mounted() {
    // Settings.fetch({ keys: ["material_image"] }).then(
    //   function (response) {
    //     if (response.data.status.isOK()) {
    //       this.thumbnailDisplay = response.data.settings.material_image;
    //     }
    //   }.bind(this)
    // );

    Materials.fetchFiledSelects({
      field_names: ["material_group", "origin", "brand", "storage_conditions"],
    }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.material_groups = response.data.material_group;
          this.material_origins = response.data.origin;
          this.material_brands = response.data.brand;
          this.material_storage_conditions = response.data.storage_conditions;
        }
      }.bind(this)
    );

    if (this.hasQueryParams()) this.$store.commit("openSearchPanel");

    if (!this.hasQueryParams()) {
      this.$commonUtils
        .loadOptions("materials", [
          "categorySelected",
          "showCategoriesSelected",
          "supplierSelected",
        ])
        .then(
          function (data) {
            if (data.options) {
              this.options = data.options;
            } else this.resetSearch();

            data.selecteds.forEach((selected) => {
              switch (selected.key) {
                case "categorySelected":
                  this.categorySelected = selected.value;
                  break;
                case "showCategoriesSelected":
                  this.showCategoriesSelected = selected.value;
                  break;
                case "supplierSelected":
                  this.supplierSelected = selected.value;
                  break;
              }
            });
          }.bind(this)
        );
      var options = sessionStorage.getItem("materials-options");
      if (
        typeof options != "undefined" &&
        options != null &&
        options != "null"
      ) {
        options = JSON.parse(options);
        this.options = options;
      } else this.resetSearch();

      var categorySelected = sessionStorage.getItem(
        "materials-categorySelected"
      );
      if (
        typeof categorySelected != "undefined" &&
        categorySelected != null &&
        categorySelected != "null"
      )
        this.categorySelected = JSON.parse(categorySelected);

      var showCategoriesSelected = sessionStorage.getItem(
        "materials-showCategoriesSelected"
      );
      if (
        typeof showCategoriesSelected != "undefined" &&
        showCategoriesSelected != null &&
        showCategoriesSelected != "null"
      )
        this.showCategoriesSelected = JSON.parse(showCategoriesSelected);
      let supplierSelected = sessionStorage.getItem(
          "materials-supplierSelected"
      );
      if (
        typeof supplierSelected != "undefined" &&
          supplierSelected != null &&
          supplierSelected != "null"
      )
        this.supplierSelected = JSON.parse(supplierSelected);
    }
  },

  data: () => ({
    importBtnMenu: false,
    formulaImportBtnMenu: false,
    exportBtnMenu: false,
    categorySelected: null,
    showCategoriesSelected: [],
    supplierSelected: [],
    materialKeyword: "",
    material_groups: [],
    material_origins: [],
    material_brands: [],
    material_storage_conditions: [],
    options: JSON.parse(
      sessionStorage.getItem("materials-options")
        ? sessionStorage.getItem("materials-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    materials: [],
    currentItem: null,
    currentItemMode: null,
    deleteDialog: false,
    deleteAlertDialog: false,
    deleteAlert: {},
    ImportDialog: false,
    combineFormulaImportDialog: false,
    splitFormulaImportDialog: false,
    excelFile: null,
    combineFormulaExcelFile: null,
    splitFormulaExcelFile: null,
    thumbnailDisplay: false,
    importMaterialsResultFlg: false,
    importMaterialsResult: [],
    batchImportDialog: false,
    zipImportAlbumsDialog: false,
    zipFile: null,
    albumZipFile: null,
    ImportImagesDialog: false,
    errorShopData: [],
    errorShopDataDialog: false,
    error_psi_stock_take: [],
    error_psi_stock_out_order: [],
    error_psi_stock_in_order: [],
    batchUpdatePublicBtnMenu: false,
    currentItemPublic: null,
    publicFlgOnAlert: false,
    publicFlgOffAlert: false,
    publicErrFlg: false,
    publicErrData: null,
    publicErrMsg: null,
    newAddExcelFile: null,
    newEditExcelFile: null,
    newAddImportDialog: false,
    newEditImportDialog: false,
}),

  methods: {
    resetSearch() {
      this.categorySelected = null;
      this.showCategoriesSelected = [];
      this.supplierSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [
        this.$refs.keyword,
        this.$refs.material_group,
        this.$refs.storage_conditions,
        this.$refs.brand,
        this.$refs.origin,
      ].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.materialKeyword,
      });
    },
    getMaterialsFromAPI() {
      if (this.settings && this.settings.production_module != 1) {
        delete this.options.production_attribute_flgs;
      }
      if (
        this.allow &&
        !this.$permission.permissionAllow("FoodFormula", "index")
      ) {
        delete this.options.raw_material_flgs;
      }
      Materials.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    exportExcel() {
      if (this.settings && this.settings.production_module != 1) {
        delete this.options.production_attribute_flgs;
      }
      if (
        this.allow &&
        !this.$permission.permissionAllow("FoodFormula", "index")
      ) {
        delete this.options.raw_material_flgs;
      }
      Materials.exports(this.options);
    },
    newExportExcel() {
      if (this.settings && this.settings.production_module != 1) {
        delete this.options.production_attribute_flgs;
      }
      if (
        this.allow &&
        !this.$permission.permissionAllow("FoodFormula", "index")
      ) {
        delete this.options.raw_material_flgs;
      }
      Materials.newExports(this.options);
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Materials.imports(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.importMaterialsResult = response.data.data;
                this.importMaterialsResultFlg = true;
                this.ImportDialog = false;
                this.getMaterialsFromAPI();
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [i18n.t("Material.title")])
                );
                this.ImportDialog = false;
                this.getMaterialsFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    newAddImportExcel() {
      this.$store.dispatch("fullscreenLoading");
      Materials.newAddImportExcel(this.newAddExcelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.importMaterialsResult = response.data.data;
                this.importMaterialsResultFlg = true;
                this.newAddImportDialog = false;
                this.getMaterialsFromAPI();
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [i18n.t("Material.title")])
                );
                this.newAddImportDialog = false;
                this.getMaterialsFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    newEditImportExcel() {
      this.$store.dispatch("fullscreenLoading");
      Materials.newEditImportExcel(this.newEditExcelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.importMaterialsResult = response.data.data;
                this.importMaterialsResultFlg = true;
                this.newEditImportDialog = false;
                this.getMaterialsFromAPI();
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [i18n.t("Material.title")])
                );
                this.newEditImportDialog = false;
                this.getMaterialsFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    combineFormulaImportExcel() {
      this.$store.dispatch("fullscreenLoading");
      Materials.combineFormulaImport(this.combineFormulaExcelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Material.combineFormula")])
              );
              this.combineFormulaImportDialog = false;
              this.getMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    splitFormulaImportExcel() {
      this.$store.dispatch("fullscreenLoading");
      Materials.splitFormulaImport(this.splitFormulaExcelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Material.splitFormula")])
              );
              this.splitFormulaImportDialog = false;
              this.getMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    deleteMaterial() {
      if (this.currentItem)
        Materials.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getMaterialsFromAPI(); // 删除成功的话刷新数据
            }
          }.bind(this)
        );
    },
    hasQueryParams() {
      return (
        this.$route.query.category_id || this.$route.query.show_category_id
      );
    },
    syncKingdeeMaterials() {
      this.$store.dispatch("fullscreenLoading");
      if (this.settings.push_platform == 1018)
        KingdeeWorker.addJob({
          event: "sync_materials",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Material.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      else if (this.sync_material_data_from > 0) {
        var ev = null;
        switch (this.sync_material_data_from) {
          case 1: // 金蝶
            ev = "sync_kingdee_materials";
            break;
        }
        if (ev == null) return; //万一有配置错误就不推送任务了
        YywdNewMiddleware.addJob({
          event: ev,
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Material.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      } else
        YywdMiddleware.addJob({
          event: "sync_materials",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Material.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    syncThirdMaterial() {
      this.$store.dispatch("fullscreenLoading");
      Materials.syncThirdMaterial()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("Material.syncThirdMaterial"));
              this.getMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    ImportZip() {
      this.$store.dispatch("fullscreenLoading");
      Materials.importsImg(this.zipFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Material.Import.zipObjName")])
              );
              this.batchImportDialog = false;
              this.getMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    ImportAlbumsZip() {
      this.$store.dispatch("fullscreenLoading");
      Materials.importsAlbum(this.albumZipFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [
                  i18n.t("Material.Import.albumsObjName"),
                ])
              );
              this.zipImportAlbumsDialog = false;
              this.getMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    getStockMaterials() {
      if (this.currentItem) {
        Materials.getStockMaterials(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.deleteAlert = response.data.stock_material;
              this.deleteAlertDialog = true;
            }
          }.bind(this)
        );
      }
    },
    checkEditAndDelete() {
      if (this.currentItem) {
        Materials.checkEditAndDelete(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.errorShopData = [];
              this.error_psi_stock_take = response.data.error_psi_stock_take;
              this.error_psi_stock_out_order =
                response.data.error_psi_stock_out_order;
              this.error_psi_stock_in_order =
                response.data.error_psi_stock_in_order;

              if (
                this.error_psi_stock_take.length ||
                this.error_psi_stock_out_order.length ||
                this.error_psi_stock_in_order.length
              ) {
                if (this.error_psi_stock_take.length) {
                  this.errorShopData.push({
                    identify_name: i18n.t("Material.Fields.stock_take"),
                    errorShop: this.error_psi_stock_take,
                  });
                }
                if (this.error_psi_stock_out_order.length) {
                  this.errorShopData.push({
                    identify_name: i18n.t("Material.Fields.stock_out_order"),
                    errorShop: this.error_psi_stock_out_order,
                  });
                }
                if (this.error_psi_stock_in_order.length) {
                  this.errorShopData.push({
                    identify_name: i18n.t("Material.Fields.stock_in_order"),
                    errorShop: this.error_psi_stock_in_order,
                  });
                }
                this.errorShopDataDialog = true;
              } else {
                this.deleteDialog = true;
              }
            }
          }.bind(this)
        );
      }
    },
    updateMaterialPublicFlg(public_flg, material_id) {
      var data = {
        update_public_flg: public_flg,
      };
      if (material_id) {
        data = Object.assign({}, data, { material_id: material_id });
      } else {
        if (this.settings && this.settings.production_module != 1) {
          delete this.options.production_attribute_flgs;
        }
        if (
          this.allow &&
          !this.$permission.permissionAllow("FoodFormula", "index")
        ) {
          delete this.options.raw_material_flgs;
        }
        data = Object.assign({}, data, this.options);
      }
      Materials.batchUpdateMaterialField(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getMaterialsFromAPI();
          } else if (
              response.data.error &&
              response.data.error.code &&
              response.data.error.code == "ERR668"
          ) {
            this.publicErrData = response.data.data;
            this.publicErrMsg = response.data.error.msg
            this.publicErrFlg = true;
          }
        }.bind(this)
      );
    },
    syncHuaManLouMaterials() {
      this.$store.dispatch("fullscreenLoading");
      Materials.syncHuaManLouMaterials()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getMaterialsFromAPI(); // 同步成功的话刷新数据
              this.$snackbar.success(i18n.t("Material.syncThirdMaterial"));
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
        this.getMaterialsFromAPI();
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace("/materials?id=" + this.currentItem.id);
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/materials");
        }
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getMaterialsFromAPI();
        if (!this.hasQueryParams())
          sessionStorage.setItem(
            "materials-options",
            JSON.stringify(this.options)
          );
      },
    },
    categorySelected: {
      handler() {
        this.options.category_code = this.categorySelected
          ? this.categorySelected.code
          : "";
        if (!this.hasQueryParams())
          sessionStorage.setItem(
            "materials-categorySelected",
            JSON.stringify(this.categorySelected)
          );
      },
    },
    showCategoriesSelected: {
      handler() {
        this.options.show_category_ids = this.showCategoriesSelected
          ? this.showCategoriesSelected.map((showCategory) => {
              return showCategory.id;
            })
          : "";
        if (!this.hasQueryParams())
          sessionStorage.setItem(
            "materials-showCategoriesSelected",
            JSON.stringify(this.showCategoriesSelected)
          );
      },
    },
    supplierSelected: {
      handler() {
        this.options.supplier_ids = this.supplierSelected
            ? this.supplierSelected.map((supplier) => {
              return supplier.id;
            })
            : "";
        if (!this.hasQueryParams())
          sessionStorage.setItem(
              "materials-supplierSelected",
              JSON.stringify(this.supplierSelected)
          );
      },
    },
    ImportDialog: {
      handler() {
        if (!this.ImportDialog && this.excelFile) {
          this.excelFile = null;
        }
      },
    },
    newAddImportDialog: {
      handler() {
        if (!this.newAddImportDialog && this.newAddExcelFile) {
          this.newAddExcelFile = null;
        }
      },
    },
    newEditImportDialog: {
      handler() {
        if (!this.newEditImportDialog && this.newEditExcelFile) {
          this.newEditExcelFile = null;
        }
      },
    },
    combineFormulaImportDialog: {
      handler() {
        if (!this.combineFormulaImportDialog && this.combineFormulaExcelFile) {
          this.combineFormulaExcelFile = null;
        }
      },
    },
    splitFormulaImportDialog: {
      handler() {
        if (!this.splitFormulaImportDialog && this.splitFormulaExcelFile) {
          this.splitFormulaExcelFile = null;
        }
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>